/* eslint-disable no-undefined */
import React, { createContext, useCallback, useContext, useState } from 'react';

export const initialState = {
	theme: null,
};

const ExternalSubmissionThemeStateContext = createContext(initialState);
const ExternalSubmissionThemeUpdaterContext = createContext();

function useExternalSubmissionThemeState() {
	const state = useContext(ExternalSubmissionThemeStateContext);

	if (state === undefined) {
		throw new Error(
			'useExternalSubmissionThemeState must be used within a ExternalSubmissionThemeProvider',
		);
	}

	return state;
}

function useExternalSubmissionThemeUpdater() {
	const setThemeContext = useContext(ExternalSubmissionThemeUpdaterContext);

	if (setThemeContext === undefined) {
		throw new Error(
			'useExternalSubmissionThemeUpdater must be used within a ExternalSubmissionThemeProvider',
		);
	}

	const setTheme = useCallback(
		(selectedTheme) => setThemeContext({ theme: selectedTheme }),
		[setThemeContext],
	);

	return { setTheme };
}

function ExternalSubmissionThemeProvider({ state = initialState, children }) {
	const [theme, setTheme] = useState(state);

	return (
		<ExternalSubmissionThemeStateContext.Provider value={theme}>
			<ExternalSubmissionThemeUpdaterContext.Provider value={setTheme}>
				{children}
			</ExternalSubmissionThemeUpdaterContext.Provider>
		</ExternalSubmissionThemeStateContext.Provider>
	);
}

export {
	ExternalSubmissionThemeProvider,
	useExternalSubmissionThemeState,
	useExternalSubmissionThemeUpdater,
};
